import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VariableBenefitConfigurationSubmissionData } from '../../../../../../models/submissions/variable-benefit-configuration-submission-data';

@Component({
  selector: 'app-vb-config-account-details-review-card',
  templateUrl: './vb-config-account-details-review-card.component.html',
  styleUrls: ['./vb-config-account-details-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbConfigAccountDetailsReviewCardComponent {
  @Input({ required: true }) submission!: VariableBenefitConfigurationSubmissionData;
}
